export default {
	termsAndConditions: {
		lastUpdate: 'Zadnje ažuriranje: 10. lipnja 2024',
		content: `
		<p>Uvjeti koje ćete pronaći u nastavku važni su jer:</p>
		<ul>
			<li>Oni uspostavljaju svoja zakonska prava na {siteName}.</li>
			<li>Objasnite prava koja nam dajete kada koristite {siteName}.</li>
			<li>
				Oni opisuju pravila koja svi moraju poštovati kada koriste {siteName}.
			</li>
		</ul>
		<p>
			Pažljivo pročitajte ove Uvjete, kao i naše {privacyPolicyLink} i sve druge
			dokumente navedene u ovim Uvjetima.
		</p>
		<p>Započnimo...</p>
		<h3>1. UVOD I PODACI {siteNameUpper}.</h3>
		<p>
			Web stranica {websiteLink} (u daljnjem tekstu, "Web stranica") u vlasništvu je tvrtke
			{siteName} S.L (u daljnjem tekstu, "{siteName}"), tvrtka
			osnovana u skladu sa španjolskim zakonodavstvom s adresom na Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona), nositelj CIF broja
			B-56.768.260 i registriran u trgovačkom registru Barcelone u svesku
			49065, list 0033, list B-606324, 1. upis.
		</p>
		<p>
			{siteName} vam stavlja web stranicu na raspolaganje kako biste mogli pristupiti
			upoznajte nas bolje, upoznajte usluge koje pružamo i ako želite, možete nas kontaktirati
			i, prema potrebi, sklopite ugovor s nama.
		</p>
		<h3>2. SVRHA I OPSEG PRIMJENE UVJETA KORIŠTENJA</h3>
		<p>
			Ovi uvjeti korištenja čine, zajedno s {privacyPolicyLink} i
			{cookiesPolicyLink}, pravni okvir koji regulira korištenje web stranice
			{websiteLink}. Ovi uvjeti korištenja bit će vam dostupni na web stranici
			na engleskom jeziku tako da ih u bilo kojem trenutku možete pregledati, arhivirati ili ispisati
			kad god želiš.
		</p>
		<p>
			Za bilo kakva pitanja u vezi s tretmanom koji provodi {siteName}.
			Vaših osobnih podataka posjetite naše {privacyPolicyLink} i {cookiesPolicyLink}.
			Oba će vam pravilnika biti dostupna i na engleskom jeziku kako biste mogli
			pregledajte, arhivirajte ili ispišite u bilo kojem trenutku.<br />
			{siteName} koristi kolačiće treće strane na web stranici. Da biste saznali više
			o vrsti kolačića koji se koriste na webu {websiteLink}, njihovoj svrsi i načinu
			za konfiguraciju vašeg preglednika u slučaju da ne želite da koristimo ove kolačiće,
			posjetite našu {cookiesPolicyLink}.
		</p>
		<p>
			Oba ova uvjeta korištenja, kao i {privacyPolicyLink} i 
			{cookiesPolicyLink} su pripremljeni u skladu s odredbama važećeg
			važećim propisima, između ostalog, Zakonom 34/2002 o uslugama
			Informacijsko društvo i elektronička trgovina i Uredba (EU) 2016/679 od
			Europskog parlamenta i Vijeća od 27. travnja 2016. u vezi s
			zaštita fizičkih osoba u pogledu obrade osobnih
			podatke i slobodno kruženje tih podataka i kojom Direktiva 95/46 / CE
			se ukida.
		</p>
		<h3>3. PRISTUP WEB-STRANICI I PRIHVAĆANJE</h3>
		<p>
			Pristup web stranici je besplatan osim u dijelu koji se odnosi na troškove
			povezivanje putem telekomunikacijske mreže koju pruža Internet
			davatelja pristupa s kojim ste sklopili ugovor. Možete slobodno pregledavati web stranicu
			i pristupite mu onoliko puta koliko želite. Za pristup i navigaciju web-stranicom,
			ne morate se registrirati, osim ako želite unajmiti uslugu.
		</p>
		<p>
			Korištenjem web stranice dobivate status korisnika web stranice
			(u daljnjem tekstu "Korisnik") i podrazumijeva vaše potpuno i bezrezervno prihvaćanje
			ove uvjete korištenja, kao i {privacyPolicyLink} i {cookiesPolicyLink}
			web stranice. Nadalje, slažete se da uslugu nećete koristiti u nezakonite svrhe
			svrhe.
		</p>
		<p>
			Pristupom web stranici i pregledavanjem iste izjavljujete pod svojim
			odgovornost da ste punoljetni i da imate potrebne pravne
			mogućnost pristupa web stranici i njezinog korištenja, izjavljujući također da u potpunosti
			razumjeti i prihvatiti ove uvjete korištenja bez rezerve.
		</p>
		<p>
			S druge strane, obavještavamo vas da iz pravnih razloga arhiviramo
			elektronički dokumenti u kojima su kupnje formalizirane. Možete pristupiti
			ove dokumente u bilo kojem trenutku tako da ih zatražite na: {supportLink}.
		</p>
		<h3>4. UVJETI KORIŠTENJA WEB STRANICE</h3>
		<p>
			Korisnik je suglasan koristiti Internet stranicu u skladu s ovim uvjetima korištenja,
			važeće zakonodavstvo i dobru vjeru. Stoga će korisnik odgovoriti na {siteName}.
			 i pred bilo kojom trećom stranom za štetu i gubitke koji proizlaze iz
			korištenje suprotno ovim uvjetima, zakonodavstvu i dobroj vjeri
			od strane Korisnika web stranice.
		</p>
		<h3>5. OPIS USLUGE</h3>
		<p>
			Preko usluge {siteName} dopušta pretplatu na uslugu
			izvršiti uređivanje slika.
		</p>
		<p>
			Jezik na kojem je ugovor između {siteName} i kupca
			zaključit će se da će to biti zemlja podrijetla.<br />
			Proces kupnje u online usluzi bit će sljedeći:
		</p>
		<ol>
			<li>Morate se registrirati na web stranici s korisničkim imenom i lozinkom.</li>
			<li>
				Prilikom registracije korisnik mora odabrati jedan od planova plaćanja
				nalaze se u odjeljku Cijene i bit će im dodijeljeni krediti ovisno o
				odabrani plan. Svaki kredit omogućit će vam uređivanje jedne slike.
			</li>
			<li>
				Nakon kupnje usluge korisnik će imati administraciju
				panel gdje će pronaći:
				<ul>
					<li>
						Odjeljak s popisom svih slika koje su obrađene, tj
						možete ga uređivati koliko god puta želite i preuzimati na svoj
						uređaj.
					</li>
					<li>
						Odjeljak Planovi i plaćanja za pregled faktura i otkazivanje
						pretplata.
					</li>
					<li>Odjeljak Mog računa za mogućnost promjene postavki računa.</li>
				</ul>
			</li>
		</ol>
		<p>
			Nakon izvršene kupnje usluge potvrdit će je
			slanjem e-pošte, u roku od najviše 24 sata, na adresu koju imate
			naznačeno. Prikazat će uslugu, kako otkazati pretplatu, njezino
			iznos, primjenjive poreze, oblik plaćanja i primjenjive uvjete i
			Uvjeti.
		</p>
		<h4>5.1 Pretplata</h4>
		<p>
			Pretplata na uslugu varira ovisno o odabranom planu i bit će
			automatski obnavlja na isti vremenski period do njegovog prestanka.
			Osim ako ne otkažete svoju pretplatu, ovlašćujete nas da učitamo
			odgovarajuću godišnju pretplatu u svom načinu plaćanja.
		</p>
		<p>
			Svoju pretplatu na uslugu možete otkazati u bilo kojem trenutku i hoćete
			i dalje mu možete pristupiti do kraja godišnjeg obračunskog razdoblja. Do
			u mjeri dopuštenoj zakonom, uplate su nepovratne i ne pružamo
			povrat novca ili kredita za djelomična godišnja razdoblja pretplate.
		</p>
		<h3>6. CIJENA I POREZI</h3>
		<p>
			Cijene proizvoda ponuđenih na {siteName} izražene su u eurima
			(€) ili valuta zemlje iz koje se kupuje, vrijednost
			Dodatni porez (PDV) koji je na snazi u trenutku kupnje naplaćuje se na cijenu
			proizvoda.
		</p>
		<p>
			U svakom slučaju, operacija može biti oslobođena ili ne podliježe PDV-u, ovisno o tome
			vašu državu prebivališta ili stanje u kojem djelujete. Zbog ovog razloga,
			u nekim slučajevima konačna cijena narudžbe može se promijeniti s obzirom na
			jedan prikazan.<br />
			Nabave koje izvrše subjekti oslobođeni plaćanja PDV-a označit će to sa
			slanje svog PDV/NIF broja e-poštom na {supportLink}, bez snimanja
			kupovine s navedenim porezom.
		</p>
		<h3>7. NAČIN PLAĆANJA</h3>
		<p>
			Online plaćanje kupljene usluge moguće je izvršiti kreditnom ili debitnom karticom.
			U tom smislu {siteName} obavještava vlasnike kreditnih i debitnih kartica da
			transakcije u online trgovini provode se putem sigurnog plaćanja
			gateway, koristeći SSL tehnologiju za jamčenje sigurnosti prijenosa podataka.
		</p>
		<h3>8. PRAVO NA ODUSTAJANJE I POVRAT NOVCA</h3>
		<h4>8.1. Pravo na odustanak</h4>
		<p>
			S obzirom na vrstu proizvoda koji se prodaje u našoj online usluzi, softver u digitalnom obliku
			formatu QR, pravo na odustajanje neće biti primjenjivo prema
			članak 103., slovo m) Kraljevskog zakonodavnog dekreta 1/2007 od 16. studenog,
			da je prerađeni tekst Općeg zakona o zaštiti potrošača i
			Korisnici i drugi dopunski zakoni su odobreni.
		</p>
		<h4>8.2. Povrat novca</h4>
		<p>
			Bez obzira na plan koji je odabrao korisnik, iznosi koje plaća korisnik i do
			u mjeri dopuštenoj zakonom neće biti povrata.
		</p>
		<p>
			Ugovorena usluga ne smije se ustupati ili prenositi na druge korisnike
			usluga.
		</p>
		<p>
			U svakom slučaju korisnik može koristiti ugovorenu uslugu do kraja
			ugovoreno razdoblje.
		</p>
		<h3>9. VALJANOST PONUDA</h3>
		<p>
			Usluge ponuđene u Usluzi i njihove cijene bit će dostupne za
			kupnju dok su u katalogu usluga prikazanih kroz ovo
			web stranica.
		</p>
		<p>
			U svakom slučaju, {siteName} zadržava pravo izmjene
			smatra prikladnim u Usluzi, mogućnost ažuriranja proizvoda i usluga
			ovisno o tržištu.
		</p>
		<p>
			{siteName} zadržava pravo promjene cijena bez prethodne najave. Mi
			obavještavamo vas da unatoč ažuriranjima cijena
			Usluga, mogu sadržavati pogreške. Odmah ćemo ispraviti sve pogreške koje
			pojaviti, ali oni neće biti obvezujući za uslugu.
		</p>
		<h3>10. SIGURNOST</h3>
		<p>
			Kao što je gore navedeno, cijeli postupak kupnje, kao i prijenos
			Vaših osobnih podataka i sustava plaćanja, provodi se na sigurnoj stranici i
			na šifriran način putem SSL protokola.
		</p>
		<p>
			Jamčimo sigurnost usluge u skladu s važećim
			tehnološka znanja. Međutim, {siteName} ne može jamčiti punu vrijednost
			buduću sigurnost usluge. U svakom slučaju, obećavamo da ćemo ispraviti i
			provesti odgovarajuće korektivne mjere za ispravljanje moguće sigurnosti
			kršenje što je prije moguće.
		</p>
		<p>
			Slažete se da ćete odmah obavijestiti {siteName} putem e-pošte {supportLink}
			bilo koje situacije koja bi mogla dovesti do lažnog predstavljanja identiteta korisnika.
		</p>
		<h3>11. IZMJENE I NIŠTAVNOST</h3>
		<p>
			Također možemo ažurirati odredbe i uvjete usluge u budućnosti
			kao značajke i funkcije same Usluge.
		</p>
		<p>
			O promjenama uvjeta obavijestit ćemo vas putem obavijesti
			na istaknutom mjestu na našoj web stranici i/ili e-poštom.
		</p>
		<p>
			Ako je bilo koja klauzula uključena u ove uvjete i odredbe deklarirana, potpuno ili
			djelomično, ništavno ili neučinkovito, to će utjecati samo na navedenu odredbu ili dio
			toga koji je ništavan ili neučinkovit. Uvjeti i odredbe bit će na snazi
			sve ostalo, što ima takvu odredbu, ili njezin dio koji je pod utjecajem
			nije postavljen.
		</p>
		<h3>12. ZAHTJEVI I RADNJE KOJE PROIZLAZE IZ UGOVORA</h3>
		<p>
			Koliko god je to moguće, ovu uslugu regulira španjolski zakon.<br />
			Kako bi se pojednostavilo rješavanje potraživanja kroz parnični postupak i
			smanjiti troškove, ne isključujemo mogućnost da se podvrgnemo
			Equity Arbitraža Arbitražnog suda trgovačkih komora i
			Industrija. U tom smislu, a prema važećim propisima,
			 {siteName} obavještava o postojanju europskog internetskog rješavanja sporova
			platforma koja olakšava izvansudsko rješavanje takvih sporova za
			ugovori sklopljeni i online između potrošača i internetske usluge
			pružatelji usluga. Ovoj platformi se može pristupiti putem sljedeće web stranice:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. PRAVA INTELEKTUALNOG I INDUSTRIJSKOG VLASNIŠTVA</h3>
		<p>
			Web stranica i njezin sadržaj podliježu zaštiti u primjeni
			važeći nacionalni propisi o intelektualnom i/ili industrijskom vlasništvu, kao
			kao iu primjeni međunarodnih konvencija koje se primjenjuju u takvim
			pitanjima. {siteName} je vlasnik ili je sve propisno licencirao
			Prava intelektualnog i industrijskog vlasništva na web stranici i njezinom sadržaju.
		</p>
		<p>
			Svaki oblik umnožavanja, distribucije, javnog priopćavanja, preoblikovanja,
			stavljanje na raspolaganje i, općenito, svaki drugi čin iskorištavanja bez obzira na to
			u komercijalne svrhe web stranice ili njezinog sadržaja, bez prethodnog
			izričiti pristanak {siteName}. Izričito je zabranjeno brisanje
			identifikacijski podaci {siteName} kao vlasnika Intelektualca i
			Prava industrijskog vlasništva web stranice ili njezinog sadržaja.
		</p>
		<p>
			{siteName} zadržava sva prava intelektualnog i industrijskog vlasništva
			nad web-stranicom i njezinim sadržajem, također pridržavajući izvršavanje bilo kakvih pravnih
			radnje koje joj odgovaraju kako bi se prestalo, spriječilo ili procesuiralo bilo koje
			nedopušteno korištenje web stranice ili njezinog sadržaja. Ni u kojem slučaju i pod br
			okolnostima pristup web-mjestu ili njegovo korištenje od strane korisnika ili treće osobe
			strane predstavljaju ili impliciraju ustupanje bilo koje vrste od strane {siteName}
			prava intelektualnog ili industrijskog vlasništva web stranice ili njezinog sadržaja.
			Ni u kojem slučaju nedostatak zahtjeva od strane {siteName} da prestane koristiti
			Web-mjesto ili njegov sadržaj može biti protuzakonit ili u suprotnosti s ovim uvjetima
			shvaćeno kao prešutni pristanak {siteName} na takve upotrebe ili kao odricanje
			izvršavanja bilo koje pravne radnje koja tome može odgovarati.
		</p>
		<h3>14. ODGOVORNOSTI I JAMSTVA</h3>
		<p>
			Korisnik je dužan koristiti Internet stranicu i njezin sadržaj u skladu s
			odredbe ovih uvjeta korištenja, važećeg zakonodavstva i dobre vjere. Bilo koje
			korištenje web stranice ili njezinog sadržaja protivno ovim općim uvjetima,
			zakonom ili u dobroj vjeri izričito je zabranjeno, bez obzira na to je li navedena uporaba
			ekonomsku svrhu ili ne.<br />
			Korisnik će biti odgovoran za bilo kakvu štetu ili štetu nanesenu {siteName}
			 ili trećim stranama proizašle izravno ili neizravno iz bilo koje uporabe
			koje Korisnik čini od web stranice ili njezinog sadržaja u suprotnosti s njima
			uvjetima, zakonu, moralu, javnom redu ili dobroj vjeri.
		</p>
		<p>
			Kako bi web mjesto i njegov sadržaj bili dostupni korisniku, {siteName}
			 zahtijeva usluge trećih strana. Moguće je da
			usprkos naporima koje {siteName} ulaže da održi web stranicu dostupnom
			i dostupan korisnicima, njegova dostupnost može biti obustavljena, prekinuta ili
			otkazan iz razloga izvan {siteName}. Zato {siteName}
			ne jamči nepostojanje prekida ili pogrešaka u pristupu
			Web mjesto ili njegov sadržaj, niti da su ažurirani ili uvijek prikazani u
			njihova najnovija verzija. Posljedično, {siteName} odbija sve
			odgovornost za štete koje mogu nastati Korisniku ili trećim osobama kao
			rezultat obustave, prekida, nedostatka kontinuiteta, ispada mreže
			ili prekida veze s web-stranicom.
		</p>
		<p>
			Ni u kojem slučaju i ni pod kakvim okolnostima {siteName} neće biti odgovoran za
			štete ili gubici koji proizlaze iz uzroka koji se ne mogu pripisati {siteName}
			 kao što je, na primjer i ni u kojem slučaju ograničavajuće, prirodno
			katastrofe, situacije više sile ili krajnje nužde, virusi, štetni
			komponenti, kvarova u pregledniku, pada mreže, upada u računalo ili
			napadi trećih strana.
		</p>
		<h3>15. VEZE</h3>
		<p>
			Web stranice, platforme, forumi, chatovi, blogovi ili vanjske društvene mreže koje
			link ili poveznica na web stranicu moraju jasno obavijestiti da nemaju
			autorizacija ili nadzor {siteName} i navedeno povezivanje ili
			veza ne uključuje, pretpostavlja ili implicira povezanost bilo koje vrste između {siteName}
			 i web stranice, platforme, forumi, chatovi, blogovi ili vanjski
			društvene mreže koje povezuju ili povezuju na web mjesto.
		</p>
		<p>
			U svakom slučaju, svaka veza koja je namijenjena web stranici mora biti usmjerena
			izravno na početnu stranicu ili početnu stranicu web stranice klikom na URL
			web stranice koja pokriva cijeli zaslon početne stranice ili početne stranice
			web stranice, tako da je poveznica apsolutna i potpuna bez korištenja
			okviri, okviri ili hiperveze. {siteName} ne odgovara ni u kojem slučaju
			i pod bilo kojim okolnostima na sadržaj, informacije ili podatke koji se odnose na
			web mjesto, njegov sadržaj ili bilo koja druga stvar sadržana na web stranicama, platformama,
			forumi, chatovi, blogovi ili društvene mreže trećih strana koje povezuju ili povezuju na
			Web stranica.
		</p>
		<p>
			Izričito je zabranjeno povezivati ili povezivati na web stranicu s web stranica,
			platforme, forumi, chatovi, blogovi ili društvene mreže protivni zakonu, moralu
			i dobrih običaja, posebno onih s pornografskim, nedopuštenim, nezakonitim ili
			sadržaj koji krši ljudska prava.
		</p>
		<p>
			S druge strane, web stranica može sadržavati poveznice na web stranice trećih strana,
			platforme, forumi, chatovi, blogovi ili društvene mreže. {siteName} ne
			imati ljudska i/ili tehnička sredstva za poznavanje ili kontrolu informacija i
			sadržaj koji se pojavljuje na web stranicama trećih strana. Stoga ni u kojem slučaju {siteName}
			 biti odgovoran za sadržaj povezanih stranica i pod br
			okolnosti mogu se navedene veze smatrati učinkovitim poznavanjem sadržaja
			web stranica na koje se povezuju.
		</p>
		<h3>16. ZAŠTITA PODATAKA</h3>
		<p>
			Kao što je navedeno u {privacyPolicyLink}, {siteName} se obvezuje koristiti korisnika
			podatke, poštivati njihovu povjerljivost i koristiti ih u skladu s
			svrhu liječenja, kao i ispuniti svoju obvezu čuvanja iste.
			i prilagoditi sve mjere kako bi se izbjegla izmjena, gubitak, liječenje ili neovlašteno
			pristup u skladu s odredbama važećeg zakonodavstva u vezi s
			zaštita osobnih podataka.
		</p>
		<p>
			Web stranica sadrži odgovarajuće zaštitne mjere i koristi se industrijskim standardom
			tehnologija za poboljšanje sigurnosti, cjelovitosti, potpunosti, točnosti i
			zaštitu osobnih podataka koje je prikupio i uspostavio
			razumne mjere opreza za zaštitu tih podataka od mogućeg gubitka ili
			zlouporaba. Njegova se pravila o zaštiti podataka i sigurnosti povremeno preispituju
			i poboljšati kada je to potrebno, te nastoji osigurati da samo ovlašteni
			osobe mogu pristupiti podacima koje je dao Korisnik.
		</p>
		<p>
			Da biste saznali više o upravljanju i liječenju koje provodi {siteName}
			 svojih podataka, pročitajte našu {privacyPolicyLink} i našu {cookiesPolicyLink}.
		</p>
		<h3>17. TRAJANJE I IZMJENE</h3>
		<p>
			Ovi uvjeti korištenja bit će na snazi sve dok su im izloženi
			korisnika, tako da čim se potpuno ili djelomično izmijene ili ažuriraju,
			ovi uvjeti prestaju biti na snazi i predstavljaju nove uvjete korištenja
			oni koji nastavljaju regulirati korištenje web stranice.
		</p>
		<p>
			{siteName} zadržava pravo da ih pregleda, izmijeni ili ažurira
			uvjete korištenja u bilo koje vrijeme. U slučaju bilo kakve promjene ovih uvjeta
			upotrebe iz bilo kojeg razloga, {siteName} će obavijestiti korisnike na početnoj stranici
			webu o navedenoj okolnosti kako bi bili uredno obaviješteni i mogli se konzultirati
			revizije, modifikacije ili ažuriranja sadašnjih uvjeta korištenja
			vaše zadovoljstvo.
		</p>
		<h3>18. OPĆENITO</h3>
		<p>
			Ni u kojem slučaju i ni pod kakvim okolnostima ne smije se izostanak ostvarivanja vaših prava
			od strane {siteName} shvatiti kao odricanje od njih.
		</p>
		<p>
			Naslovi sadržani u ovim uvjetima su samo indikativni ili
			informativni, tako da ne utječu, kvalificiraju ili proširuju tumačenje
			toga
		</p>
		<p>
			U slučaju da je bilo koja od klauzula sadržanih u ovim uvjetima bila
			proglašeno ništavnim, zlonamjernim ili neprovedivim, potpuno ili djelomično, od strane suda
			ili upravno tijelo, navedena će izjava pojedinačno utjecati na klauzulu
			u pitanju, uzimajući kao ne i bez proglašenja ništavosti, zlouporabe odn
			neprimjenjivost biti proširen pod bilo kojim okolnostima na ostatak
			uvjetima, koji će opstati.
		</p>
		<p>
			Ovi uvjeti korištenja, kao i {privacyPolicyLink} i {cookiesPolicyLink}
			podliježu važećim španjolskim propisima u svakom trenutku.
		</p>
		<h3>19. USLUGA ZA KORISNIKE</h3>
		<p>
			Za bilo kakvo pojašnjenje, incident ili zahtjev, možete nas kontaktirati putem:<br />
			E-pošta: {supportLink}<br />
			Poštanska adresa: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španjolska.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Zadnje ažuriranje: 10. lipnja 2024',
		content: `
			<h3>1. Odgovorna strana i opis</h3>
			<h5>1.1. Odgovoran</h5>
			<p>Osoba odgovorna za obradu ove stranice je Remove Background S.L (u daljnjem tekstu Remove Background 
			ili Služba), s adresom Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španjolska.</p>
			<p>NIF: B56768260<br> E-pošta: {supportLink}</p>

			<h5>1.2. Opis</h5>
			<p>Prihvaćanje pravila o privatnosti Remove Background (u daljnjem tekstu "Pravila o privatnosti") nužan je uvjet 
				za korištenje naše web stranice i pružanje usluge (u daljnjem tekstu „Usluga“).<br>
				Ova Pravila o privatnosti reguliraju prikupljanje, obradu i korištenje vaših osobnih i neosobnih podataka 
				kao korisnik Remove Background, od datuma stupanja na snagu koji se pojavljuje u zaglavlju.<br>
				Za obradu vaših osobnih podataka, Remove Background je u skladu s važećim lokalnim i europskim zakonodavstvom, 
				kao i njegove provedbene propise.</p>


			<h3>2. Prikupljene informacije</h3>
			<p>Pristup našoj web stranici može se izvršiti bez potrebe davanja bilo kakvih podataka, iako se morate registrirati i / 
				ili ugovorite naše planove morat ćete nam dati neke osobne podatke. Informacije (osobne 
				ili neosobne) koje prikuplja Usluga može varirati ovisno o tome.<br>
				Osobni i neosobni podaci koje prikupi Usluga doći će do nas na tri načina: 1) oni koji 
				prikuplja se automatski 2) ono što nam dobrovoljno date i 3) ono što nam daju treće strane.</p>

			<h5>2.1. Onaj koji se prikuplja automatski</h5>
			<p>Ove informacije će se sastojati od:</p>
			<ul>
				<li>Onaj prikupljen putem kolačića ili sličnih mehanizama pohranjenih na vašem uređaju, uvijek uz vaš pristanak ili u 
					sukladno drugim pravnim osnovama. Provjerite našu Politiku kolačića za više informacija.</li>
				<li>IP s kojeg se uspostavlja veza, vrsta korištenog uređaja i njegove karakteristike, verzija 
					operativni sustav, vrsta preglednika, jezik, datum, država, vrijeme zahtjeva, 
					URL s kojeg dolazite, URL na koji idete ili korištena mobilna mreža, između ostalog.</li>
				<li>Podaci o korištenju usluge i moguće greške otkrivene tijekom njezine upotrebe.</li>
				<li>Osim toga, Remove Background koristi Google Analytics, analitičku uslugu koju pruža Google, LLC. 
					sa sjedištem u Sjedinjenim Državama sa sjedištem na adresi 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					Za pružanje ovih usluga koriste kolačiće koji prikupljaju podatke, uključujući IP adresu korisnika, 
					koje će Google prenijeti, obraditi i pohraniti prema uvjetima utvrđenim na webu www.google.com. 
					Uključujući mogući prijenos navedenih informacija trećim stranama zbog zakonskih zahtjeva ili 
					kada navedene treće strane obrađuju informacije u ime Googlea.</li>
			</ul>
			<p>U svakom slučaju, možete onemogućiti Google Analytics kolačiće <a href="{externalLink: disableGoogleAnalyticsLink}">ovdje</a>.</p>

			<h5>2.2. Onaj koji dobrovoljno dajete</h5>
			<p>Ove informacije će se sastojati od:</p>
			<ul>
				<li>Svi podaci su obavezni.</li>
				<li>Onaj koji zahtijeva Remove Background za dovršetak vaše registracije na webu: ime i prezime, adresa i e-pošta, između ostalog.</li>
				<li>Svi podaci su obavezni.</li>
				<li>Informacije, osobne ili ne, za dovršetak ugovaranja usluge, poput vaše adrese e-pošte i broja vaše kreditne ili debitne kartice.</li>
				<li>Informacije, osobne ili ne, koje poruke poslane putem kanala za kontakt ili mišljenja uspostavljenih u Usluzi mogu sadržavati, 
					na primjer vaše ime i e-pošta.</li>
			</ul>

			<h5>2.3. Onaj koji pružaju treće strane</h5>
			<p>Ove informacije će se sastojati od:</p>
			<ul>
				<li>Onaj koji pružaju sustavi plaćanja ili procesori kreditnih kartica, kao što je vrijeme kupnje ili njezin iznos.</li>
			</ul>


			<h3>3. Prava i svrhe</h3>
			<p>Obavještavamo vas da je ispunjavanje obrazaca dobrovoljno. Međutim, ako ne ispunite potrebna polja 
				(obično označeno zvjezdicom), korištenje nekih funkcija Usluge neće biti moguće ili će biti ograničeno.<br>
				Osobni podaci koje nam dostavite bit će uključeni i obrađeni u Registru aktivnosti liječenja Uklanjanje pozadine 
				kako bismo mogli udovoljiti vašim zahtjevima, pružiti traženu uslugu i informirati vas o stvarima vezanim uz djelatnost 
				tvrtke i njenih usluga.<br>
				U svakom trenutku možete ostvariti prava pristupa, ispravljanja, brisanja, ograničenja vašeg liječenja, 
				protivljenje i prenosivost vaših osobnih podataka e-poštom na adresu: {supportLink} ili poštansku adresu: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španjolska.<br>
				U oba slučaja morate se identificirati svojim imenom i prezimenom, kao i preslikom DNI ili osobne iskaznice, ako je potrebno.<br>
				U slučaju da ste dali privolu za određenu svrhu, imate pravo povući privolu u bilo kojem trenutku, 
				bez utjecaja na zakonitost liječenja na temelju pristanka prije njegovog povlačenja.<br>
				Osim toga, ako smatrate da postoji problem s načinom na koji Remove Background rukuje vašim podacima, 
				svoje pritužbe možete uputiti odgovarajućem <a href="{knowYourRightsLink}">tijelu za zaštitu podataka</a>, a to je <a href="{aepdLink}">španjolska agencija za zaštitu podataka</a> 
				onaj naznačen u slučaju Španjolske.</p>


			<h3>4. Dob</h3>
			<p>Što se tiče korištenja internetske usluge, izjavljujete da ste punoljetni i da imate potrebne pravne 
				sposobnost da budete vezani ovim ugovorom i koristite stranicu u skladu s njezinim odredbama i uvjetima, koje u potpunosti ispunjavate 
				razumjeti i priznati.<br>
				Izjavljujete da su svi podaci koje dajete za pristup Usluzi, prije i tijekom njezine upotrebe, istiniti, potpuni 
				i točan.</p>


			<h3>5. Korištenje podataka</h3>
			<p>Uklanjanje pozadine koristit će prikupljene podatke za:</p>
			<ul>
				<li>Upravljanje i ažuriranje usluge (pravni temelj je naš legitimni interes za održavanje i održavanje usluge 
					ažuriran iu dobrom stanju).</li>
				<li>Odgovorite na pitanja koja postavljate (pravni temelj je naš legitimni interes da odgovorimo na zahtjeve i 
					sumnje naših korisnika).</li>
				<li>Obradite plaćanja koja izvršite (ugovor je pravna osnova).</li>
				<li>Pružite ugovorenu uslugu (ugovor je pravna osnova).</li>
				<li>Održavati sigurnost Usluge, istraživati nezakonite aktivnosti, provoditi naše odredbe i uvjete i
					pomoći državnim snagama sigurnosti u okviru njihovih mogućih istraga (pravna osnova je naša 
					legitimni interes za jamčenje i održavanje sigurnosti Usluge i njezinih korisnika).</li>
			</ul>
			<p>Ukloni pozadinu ne koristi automatizirane odluke, iako može generirati osnovne korisničke profile, 
				pravna osnova je naš legitimni interes za komercijalne svrhe i pružanje personaliziranih ponuda.<br>
				Također, Remove Background može koristiti podatke o korisniku u obliku agregiranih i anonimnih podataka kako bi ih pokazao trećim stranama. 
				Također možete dijeliti statistike i demografske podatke o korisnicima i njihovoj upotrebi usluge s trećim stranama. 
				Ali ništa od ovoga neće dopustiti tim trećim stranama da vas osobno identificiraju.</p>

			<h5>5.1. U e-pošti i obrascima za kontakt</h5>
			<p>Web stranica ima SSL enkripciju koja korisniku omogućuje sigurno slanje osobnih podataka putem standardnih obrazaca za kontakt.<br>
				Prikupljeni osobni podaci bit će predmet automatizirane obrade i ugrađeni u odgovarajuće datoteke 
				zapisa o aktivnostima obrade i čiji je vlasnik Remove Background.</p>
			<p>U tom smislu:</p>
			<ul>
				<li>Primit ćemo vašu IP adresu koja će se koristiti za provjeru podrijetla poruke kako bismo vam ponudili odgovarajuće 
					preporuke (primjerice, prezentirati informacije na ispravnom jeziku) i otkriti moguće nepravilnosti 
					(na primjer, mogući pokušaji kibernetičkog napada na uslugu), kao i podaci koji se odnose na vašeg ISP-a.</li>
				<li>Isto tako, svoje podatke nam možete dostaviti telefonom, e-poštom i drugim naznačenim načinom komunikacije.</li>
			</ul>
			<p>U vezi s korištenim sredstvom plaćanja:</p>
			<ul>
				<li>Naši pružatelji usluga plaćanja za plaćanje pružanja naših usluga su kreditne ili debitne kartice. 
					Ni u jednom trenutku Usluga ili njezino osoblje neće imati pristup bankovnim podacima (na primjer, broju kreditne kartice) 
					koje će korisnik kao kupac dati tim trećim stranama.</li>
			</ul>


			<h3>6. Zadržavanje podataka</h3>
			<p>U nastavku je navedeno koliko se dugo čuvaju podaci koje obrađuje Usluga:</p>
			<ul>
				<li>Razvrstani podaci će se čuvati bez razdoblja brisanja.</li>
				<li>
					Podaci o kupcima čuvat će se onoliko koliko je potrebno i mogu se čuvati do:
					<ul>
						<li>5 godina, prema čl. 1964. Građanskog zakonika (osobne tužbe bez posebnog roka).</li>
						<li>6 godina, prema čl. 30. Trgovačkog zakona (npr. računovodstvene knjige ili računi).</li>
					</ul>
				</li>
				<li>Podaci korisnika čuvat će se najviše 12 mjeseci kako bi se moglo ispuniti njihove zahtjeve.</li>
			</ul>


			<h3>7. Podaci podijeljeni s trećim stranama</h3>
			<p>Postoje treće strane koje upravljaju dijelom usluge.<br>
				Uklanjanje pozadine zahtijeva od njih da se pridržavaju ovih Pravila o privatnosti ako su primjenjiva, osim što imaju vlastita. Međutim, Remove Background neće biti odgovoran za usklađenost s navedenom politikom.<br>
				Pod određenim okolnostima, Remove Background može dijeliti, koristiti ili sačuvati s trećim stranama sve prikupljene osobne podatke:</p>
			<ul>
				<li>Za pružanje usluge:</li>
			</ul>
			<p>Pružatelji usluga koji obavljaju funkcije u naše ime, kao što su usluge plaćanja, web hosting, poslovna analitika, korisnička služba ili web marketing. Ovi pružatelji usluga mogu prikupljati i imati pristup informacijama koje su im potrebne za obavljanje njihovih funkcija, ali im nije dopušteno dijeliti ili koristiti informacije u bilo koju drugu svrhu.</p>
			<ul>
				<li>Surađivati s nadležnim tijelima:</li>
			</ul>
			<p>Ako vjerujemo da je razumno potrebno zadovoljiti bilo koji zakon, pravni postupak ili legitimni interes. U svakom slučaju, pružit ćemo samo one podatke koji su strogo potrebni.</p>


			<h3>8. Sigurnosne mjere</h3>
			<p>Ukloni pozadinu usvaja sve tehničke i organizacijske mjere potrebne za
				zaštititi sigurnost i integritet prikupljenih osobnih i neosobnih podataka. 
				I protiv neovlaštenog pristupa i njegove slučajne izmjene, gubitka ili uništenja.<br>
				U svakom slučaju, Remove Background ne može jamčiti apsolutnu sigurnost prikupljenih podataka, 
				tako da morate surađivati i koristiti zdrav razum o informacijama koje se dijele u svakom trenutku.<br>
				Razumijete i prihvaćate da, čak i nakon brisanja, osobni i neosobni podaci mogu 
				ostati vidljiv u predmemoriji ili ako su ga drugi korisnici kopirali ili pohranili.</p>


			<h3>9. Promjene Pravila o privatnosti</h3>
			<p>Možda ćemo ažurirati ovu Politiku privatnosti u budućnosti. O njezinim promjenama obavijestit ćemo vas slanjem obavijesti na navedenu e-mail adresu i/ili postavljanjem obavijesti na istaknuto mjesto na našoj web stranici.</p>


			<h3>10. Kontakt</h3>
			<p>Ako imate pitanja o ovim Pravilima privatnosti, kontaktirajte nas na:</p>
			<p>E-pošta: {supportLink}<br> 
				Adresa: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španjolska.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Zadnje ažuriranje: 10. lipnja 2024',
		content: `
			<h3>1. Tko je odgovoran i kako ih kontaktirati?</h3>
			<p>Upravitelj ove stranice je Remove Background S.L s adresom Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španjolska.</p>
			<p>Možete ga kontaktirati putem e-pošte na {supportLink}.</p>

			<h3>2. Koji se podaci prikupljaju?</h3>
			<p>
				Automatski prikupljamo podatke putem kolačića koje učitavamo na vaš uređaj, uključujući analitiku. 
				Također prikupljamo IP s kojeg je uspostavljena veza, vrstu korištenog uređaja i njegove karakteristike, 
				verziju operativnog sustava, vrstu preglednika, jezik, datum, državu, vrijeme zahtjeva, 
				URL s kojeg dolazite, URL na koji idete ili korištena mobilna mreža, između ostalog.<br>
				Korisnik nam dobrovoljno daje neke podatke kao što su ime i prezime, e-mail ili bankovni podaci 
				kako biste nas mogli kontaktirati, prijaviti se za uslugu ili kupiti pretplatu.
			</p>

			<h3>3. Za što se koriste prikupljeni podaci?</h3>
			<p>
				Usluga će koristiti prikupljene podatke, između ostalog, za administriranje i ažuriranje usluge, odgovaranje na vaše zahtjeve, 
				slati vam naš bilten i promotivne ponude e-poštom, upravljati vašom registracijom na platformi, upravljati i pružati 
				usluge koje se odnose na vašu pretplatu, obrađuju uplate koje izvršite i izdaju odgovarajuće račune, 
				održavati sigurnost usluge, istraživati nezakonite aktivnosti, provoditi naše odredbe i uvjete i 
				pomoći državnim snagama i tijelima sigurnosti u okviru njihovih eventualnih istraga.
			</p>

			<h3>4. Koliko se dugo čuvaju?</h3>
			<ul>
				<li>Razvrstani podaci će se čuvati bez razdoblja brisanja.</li>
				<li>
					Podaci o kupcima čuvat će se onoliko koliko je potrebno i mogu se čuvati do:
					<ul>
						<li>5 godina, prema čl. 1964. Građanskog zakonika (osobne tužbe bez posebnog roka).</li>
						<li>6 godina, prema čl. 30. Trgovačkog zakona (npr. računovodstvene knjige ili račun).</li>
					</ul>
				</li>
				<li>Podaci korisnika čuvat će se maksimalno 12 mjeseci kako bi se ispunili njihovi zahtjevi.</li>
				<li>Korisnički podaci koje je Usluga učitala na stranice i profile na društvenim mrežama čuvat će se od trenutka kada korisnik ponudi svoj pristanak do njegovog povlačenja.</li>
			</ul>

			<h3>5. Koja su vaša prava kao korisnika?</h3>

			<p>
				Pravo pristupa: Pogođena strana ima pravo od voditelja obrade podataka dobiti potvrdu o tome je li 
				ili se osobni podaci koji se odnose na njega ili nju ne obrađuju.
			</p>
			<p>
				Pravo na ispravak: pogođena strana ima pravo zatražiti, bez nepotrebnog odgađanja, od voditelja obrade podataka 
				ispravak osobnih podataka koji su netočni i koji ga izravno utječu. Isto tako će zainteresirana strana 
				imaju pravo na dopunu nepotpunih osobnih podataka, uključujući i dodatnom izjavom.
			</p>
			<p>
				Pravo na brisanje: Pravo je pogođene strane ishoditi, bez nepotrebnog odgađanja, od voditelja obrade podataka brisanje 
				osobnih podataka koji se na njega odnose.
			</p>
			<p>
				Pravo na ograničenje obrade podataka: sastoji se u dobivanju ograničenja obrade Vaših podataka od strane odgovorne osobe, 
				iako njegova provedba ima dva aspekta: 1) kada osporavate točnost svojih osobnih podataka, tijekom razdoblja koje dopušta 
				nadležna osoba da to provjeri i 2) Kada ste se usprotivili obradi Vaših osobnih podataka koju nadležna osoba 
				obavlja na temelju legitimnog interesa ili misije od javnog interesa, a odgovorna osoba provjerava jesu li ti razlozi 
				prevladati nad vašim.
			</p>
			<p>
				Pravo na prenosivost podataka: Pravo je pogođene strane primiti osobne podatke koji se na nju odnose, 
				koje je dostavio voditelju obrade podataka, u strukturiranom formatu, za zajedničku upotrebu i mehaničko čitanje, i 
				prenijeti ih drugom voditelju obrade bez sprječavanja voditelja obrade kojemu su dostavljene.
			</p>
			<p>
				U tom smislu, zainteresirana strana će imati pravo na prijenos osobnih podataka izravno od voditelja obrade 
				kontroloru kada je to tehnički moguće.
			</p>

			<h3>6. Kako možete ostvariti svoja prava?</h3>

			<p>
				Svoja prava na osobne podatke možete ostvariti u bilo kojem trenutku slanjem e-pošte na: {supportLink} ili poštansku adresu: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Španjolska. U oba slučaja morate se identificirati imenom i prezimenom, 
				kao i kopiju vašeg DNI ili osobne iskaznice, ako je potrebno.<br>
				Osim toga, ako smatrate da postoji problem s načinom na koji Remove Background obrađuje vaše podatke, možete uputiti svoje zahtjeve 
				odgovarajućem <a href="{knowYourRightsLink}">tijelu za zaštitu podataka</a>, a to je <a href="{aepdLink}">španjolska agencija za zaštitu podataka</a> 
				onaj naznačen u slučaju Španjolske.
			</p>

			<h3>7. Jesu li poduzete sigurnosne mjere?</h3>
			<p>
				Služba poduzima sve potrebne tehničke i organizacijske mjere za zaštitu sigurnosti i integriteta osobnih podataka 
				i prikupljene podatke koji nisu osobni. I protiv neovlaštenog pristupa i slučajne izmjene, gubitka ili uništenja.<br>
				U svakom slučaju, Usluga ne može jamčiti apsolutnu sigurnost prikupljenih podataka, stoga morate surađivati i 
				uvijek koristite zdrav razum u vezi s dijeljenim informacijama.<br>
				Razumijete i prihvaćate da, čak i nakon brisanja, osobni i neosobni podaci mogu ostati vidljivi u predmemoriji ili 
				ako su kopirani ili pohranjeni od strane drugih korisnika.
			</p>

			<h3>8. Postoje li prijenosi osobnih podataka ili međunarodni prijenosi?</h3>

			<p>
				Ne prenosimo podatke niti međunarodne prijenose. Međutim, postoje treće strane koje upravljaju dijelom Usluge 
				da zahtijevamo usklađenost s našom Politikom privatnosti u onoj mjeri u kojoj je primjenjiva na njih i da oni imaju vlastitu. 
				Ove treće strane su pružatelji usluga koji obavljaju funkcije u naše ime, kao što su web hosting, 
				praćenje analitike ili web razvoj.<br>
				Također, ako vjerujemo da je razumno potrebno zadovoljiti bilo koji zakon, pravni proces ili legitimni interes. 
				U svakom slučaju, dat ćemo samo strogo potrebne podatke.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Zadnje ažuriranje: 21. lipnja 2024',
		content: `
			<h3>Sažetak</h3>
			<ul>
			    <li>Kolačići koji se koriste: <strong>vlastiti i kolačići treće strane</strong></li>
			    <li>Koriste li se za dobivanje statistike? <strong>Da, na temelju našeg legitimnog interesa za boljim upravljanjem uslugom.</strong></li>
			    <li>Usluge trećih strana koje instaliraju kolačiće putem ove web stranice: <strong>Google, Google Analytics, Cloudflare i Stripe.</strong></li>
			</ul>

			<h3>Kako konfigurirati i onemogućiti kolačiće</h3>
			<p>
			    Možete dopustiti, blokirati ili izbrisati kolačiće instalirane na vašem uređaju iz vašeg web preglednika. Ako ne dopustite instaliranje kolačića na vaš uređaj, 
			    iskustvo pregledavanja može se pogoršati. U nastavku možete pronaći kako konfigurirati kolačiće u svakom pregledniku:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Vrste i upotreba</h3>
			<p>Usluga koristi vlastite kolačiće i kolačiće trećih strana za poboljšanje pregledavanja, pružanje usluge i dobivanje statistike o korištenju web stranice.</p>

			<h3>2. Što je kolačić i za što se koristi?</h3>
			<p>
			    Kolačić je tekstualna datoteka koja se šalje na web-preglednik vašeg računala, mobitela ili tableta i koristi se za pohranjivanje i dohvaćanje informacija o
			    pregledavanje obavljeno. Na primjer, da biste zapamtili svoje korisničko ime i lozinku ili svoje postavke profila.
			</p>

			<h3>3. Koje vrste kolačića postoje?</h3>
			<p>Prema tome tko njima upravlja:</p>
			<ul>
			    <li>Vlastiti kolačići; šalju se vašem pregledniku s naše vlastite opreme ili web domena.</li>
			    <li>Kolačići treće strane; oni se šalju u vaš preglednik s opreme ili web domena kojima ne upravljamo izravno, već od strane trećeg subjekta kao što je Google.</li>
			</ul>
			<p>Na temelju toga koliko dugo ostaju aktivni, postoje:</p>
			<ul>
			    <li>Kolačići sesije; oni ostaju u datoteci kolačića vašeg preglednika dok ne napustite web mjesto, tako da nijedan ne ostaje na vašem uređaju.</li>
			    <li>Trajni kolačići; oni ostaju na vašem uređaju i naša web stranica ih čita svaki put kada ponovno posjetite. Ovi kolačići prestaju raditi nakon određenog datuma.</li>
			</ul>
			<p>Na kraju, prema njihovoj namjeni, imamo:</p>
			<ul>
			    <li>Tehnički kolačići; poboljšavaju pregledavanje i pravilan rad web stranice.</li>
			    <li>Personalizacijski kolačići; omogućuju pristup usluzi s unaprijed definiranim karakteristikama na temelju niza kriterija.</li>
			    <li>Analitički kolačići; omogućuju mjerenje i statističku analizu korištenja pružene usluge.</li>
			</ul>
			<p>Popis kolačića treće strane koje koristi <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: njihovi kolačići (NID ili CONSENT) omogućuju personalizaciju načina na koji se oglasi prikazuju izvan Googlea ili pohranjivanje informacija
			        kao što je željeni jezik pri prikazu rezultata pretraživanja.<br><a href="{externalLink: googleCookieTypes}">Više informacija</a> o vrstama kolačića koje Google koristi u svojim raznim uslugama.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: njihovi kolačići (kao što je _ga) omogućuju brojanje koliko puta korisnik posjećuje web stranicu, kako, kada i odakle.<br>
			        U svakom slučaju, kolačiće Google Analytics možete onemogućiti <a href="{externalLink: disableGoogleAnalytics}">ovdje</a>.
			    </li>
			    <li>Cloudflare: Da biste saznali više o Cloudflareovim pravilima o kolačićima i korištenju, kliknite <a href="{externalLink: cloudflareCookiesPolicy}">ovu vezu</a>.</li>
			    <li>Stripe: pronađite informacije <a href="{externalLink: stripeCookiesPolicy}">ovdje</a> o politici kolačića i upotrebi Stripea.</li>
			</ul>
		`
	}
};
